import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef, useState, useRef, useImperativeHandle, } from "react";
import { Modal, Spinner, Button, boxError } from ".";
import { currentRef } from "./util";
export const ConfirmationModal = forwardRef(({ title: titleOverride, buttonContent, onSubmit, text, children, }, ref) => {
    const title = titleOverride ?? text.areYouSure;
    const [inFlight, setInFlight] = useState(false);
    const [error, setError] = useState();
    const modalRef = useRef(null);
    useImperativeHandle(ref, () => ({
        open: () => {
            setInFlight(false);
            setError(undefined);
            currentRef(modalRef).open();
        },
        done: () => {
            currentRef(modalRef).close?.();
        },
        reportError: (error) => {
            setInFlight(false);
            setError(error);
        },
    }));
    const onSubmitWrapper = (event) => {
        event.preventDefault();
        // Don't let the event escape the portal,
        //   which might be sitting inside of other `form` elements.
        event.stopPropagation();
        setInFlight(true);
        setError(undefined);
        onSubmit?.();
    };
    return _jsxs(Modal, { title: title, closable: !inFlight, ref: modalRef, text: text, children: [children, _jsxs("form", { onSubmit: onSubmitWrapper, css: { marginTop: 32 }, children: [_jsxs("div", { css: {
                            display: "flex",
                            gap: 12,
                            justifyContent: "center",
                            flexWrap: "wrap",
                        }, children: [_jsx(Button, { disabled: inFlight, onClick: () => currentRef(modalRef).close?.(), children: text.cancel }), _jsx(Button, { disabled: inFlight, type: "submit", kind: "danger", css: {
                                    whiteSpace: "normal",
                                }, children: buttonContent })] }), inFlight && _jsx("div", { css: { marginTop: 16 }, children: _jsx(Spinner, { size: 20 }) })] }), boxError(error)] });
});
//# sourceMappingURL=confirmationModal.js.map